<script>
  import Text from '@components/general/text.svelte'
  import Button from '@components/buttons/button.svelte'
  import Tag from '@components/general/tag.svelte'
  import Image from '@components/general/image.svelte'
  import { Download, ExternalLink, ArrowRight, Lock } from 'lucide-svelte'
  import { filesize } from 'filesize'
  import { page } from '@inertiajs/svelte'

  let { resource } = $props()

  let user = $page.props.user
  let isLocked = $derived(!resource.free && (!user.is_admin && !user?.has_active_membership))
  let isLink = $derived(resource.resource_type === 'link')
</script>

<!-- A grid item for a resource -->
<Button variant="naked" path={`/resources/${resource.id}`} class="w-full block hover:ring-2 hover:ring-gray-100 ring-offset-2">
  
  <!-- The image backdrop -->
  <div class={`bg-linear-to-tr from-yellow-50/30 to-gray-100 rounded-sm shadow-md aspect-video relative flex items-center justify-center ${isLocked ? 'grayscale opacity-50' : ''}`}>

    {#if isLocked}
      <span aria-hidden="true" class="pointer-events-none absolute inset-0 z-10 bg-gray-900/20"></span>
      <Lock size={32} class="absolute left-1/2 top-1/2 z-20 -translate-x-1/2 -translate-y-1/2 rounded-full bg-white/90 p-2 text-gray-400" />
    {:else}
      <!-- Top left sits a subtle action icon -->
      {#if isLink}
        <Button variant="naked" Icon={ExternalLink}
          class="absolute top-3 left-3 bg-white/80 rounded-full p-2 text-gray-600 shadow-sm hover:text-gray-700"
          hint="Visit resource"
          externalPath={resource.url} />
        <div class="absolute bottom-3 right-3 bg-white/80 px-1 py-0.5 rounded-sm text-gray-500 text-xs shadow-sm">
          External Link
        </div>
      {:else if resource.file}
        <Button variant="naked" Icon={Download} 
          class="absolute top-3 left-3 bg-white/80 rounded-full p-2 text-gray-600 shadow-sm hover:text-gray-700"
          hint="Download resource"
          externalPath={resource.file.url} />

        <!-- Bottom right sits a subtle text with the extension + filesize -->
        <div class="absolute bottom-3 right-3 bg-white/80 px-1 py-0.5 rounded-sm text-gray-500 text-xs shadow-sm">
          {resource.file.extension.toUpperCase()} · {filesize(resource.file.byte_size)}
        </div>
      {/if}
    {/if}

    <!-- A horizontal line across the page fairly low down -->
    <div class="absolute bottom-[30%] left-0 right-0 h-px bg-gray-200"></div>

    <!-- A page representing the resource; Either a cover image (first) or a white placeholder -->
    {#if resource.cover_image}
      <Image src={resource.cover_image.thumb_url} alt={resource.cover_image.name} width={100} height={100} class="rounded-sm shadow-md h-[80%] w-[34%] z-10" />
    {:else}
      <div class="bg-white rounded-sm shadow-md p-4 h-[70%] w-[30%] z-10"></div>
    {/if}

  </div>

  <!-- A flex column showing name and tags -->
  <div class="flex flex-col gap-2 p-2 mt-2">
    <Text variant="section_title" as="h5" text={resource.name} class="text-[14px] leading-none" />
    {#if resource.tags?.length > 0}
      <div class="flex flex-wrap gap-1">
        {#each resource.tags as tag (tag.id)}
          <Tag {tag} size="xs" class="rounded-md px-[6px]" variant="faint" path={`/resources?tag=${tag.id}`} />
        {/each}
      </div>
    {/if}
  </div>
   
</Button>